import { ContentSeries } from '@/client/courses';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { resolveTextDirection } from '@/utils/helpers/language.helper';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  width: 600px;
`;

export type PendingSeriesToggle = {
  series: ContentSeries;
  nextValue: boolean;
};

type SeriesToggleConfirmDialogProps = {
  pendingToggle: PendingSeriesToggle | null;
  onConfirm: () => void;
  onCancel: () => void;
};

export const SeriesToggleConfirmDialog: React.FC<
  SeriesToggleConfirmDialogProps
> = ({ pendingToggle, onConfirm, onCancel }) => {
  const { t, i18n } = useTranslation();
  const resolvedDir = resolveTextDirection(i18n.language);

  if (!pendingToggle) {
    return null;
  }

  const seriesLabel = t(`content.series.${pendingToggle.series}`);
  const transition = pendingToggle.nextValue ? 'on' : 'off';

  return (
    <StyledDialog
      pt={{ root: { dir: resolvedDir } }}
      blockScroll
      visible
      header={t(`planner.series.toggle.${transition}.warn.heading`, {
        series: seriesLabel,
      })}
      draggable={false}
      data-testid="series-toggle-confirm-modal"
      onHide={onCancel}
    >
      <p>
        {t(`planner.series.toggle.${transition}.warn.text`, {
          series: seriesLabel,
        })}
      </p>
      <FlexContainer justify="flex-end" className="mt-5">
        <>
          <AppButton
            label={t('button.cancel')}
            type="outlined"
            className="mr-3"
            onClick={onCancel}
          />
          <AppButton
            label={
              pendingToggle.nextValue
                ? t('generic.enable')
                : t('generic.disable')
            }
            onClick={onConfirm}
          />
        </>
      </FlexContainer>
    </StyledDialog>
  );
};
